<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('settings')">Einstellungen</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span> Erschaffen
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.key" :error="form.errors.key" class="pr-6 pb-8 w-full lg:w-1/2" label="Schlüssel">
            <option v-for="(setting, index) in settings" :key="index" :value="setting.key">{{ setting.key }}</option>
          </select-input>
          <text-input v-model="form.value" :error="form.errors.value" class="pr-6 pb-8 w-full lg:w-1/2" label="Value" />
          <text-input v-model="form.text" :error="form.errors.text" class="pr-6 pb-8 w-full lg:w-full" label="Text" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-green" type="submit">Speichern</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'


export default {
  metaInfo: { title: 'Create Setting' },
  components: {
    SelectInput,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    settings: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        key: null,
        value: null,
        text: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('settings.store'))
    },
  },
}
</script>

